import React from 'react';
import { Typography, Row, Col, Statistic, Card } from 'antd';
import { ThunderboltOutlined, StarOutlined, GlobalOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Text, Title } = Typography;

const SocialProof = () => {
  const { t } = useTranslation();

  const stats = [
    {
      icon: <StarOutlined style={{ fontSize: '24px', color: '#52c41a' }} />,
      value: '93%',
      label: t('social_proof.stats.customer_rating')
    },
    {
      icon: <ThunderboltOutlined style={{ fontSize: '24px', color: '#faad14' }} />,
      value: '100,000+',
      label: t('social_proof.stats.generated_notes')
    },
    {
      icon: <GlobalOutlined style={{ fontSize: '24px', color: '#1890ff' }} />,
      value: '30+',
      label: t('social_proof.stats.countries')
    },
  ];

  return (
    <div style={{ 
      backgroundColor: '#ffffff',
      padding: '24px 0',
      marginTop: '44px',
      borderRadius: '16px'
    }}>
      <Row justify="center">
        <Col xs={24} sm={24} md={22} lg={20} xl={16}>
          <div style={{ 
            maxWidth: '900px', 
            margin: '0 auto',
            textAlign: 'center'
          }}>
            <Title level={4} style={{ fontWeight: '500' }}>
              {t('social_proof.trusted_by')}
            </Title>
            
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'stretch',
                gap: '24px',
                flexWrap: 'wrap',
                maxWidth: '900px',
                margin: '0 auto',
              }}
            >
              {stats.map((stat, index) => (
                <Card 
                  key={index}
                  style={{ 
                    flex: '1 1 0',
                    minWidth: 220,
                    maxWidth: 300,
                    textAlign: 'center',
                    border: 'none',
                    boxShadow: 'none',
                    backgroundColor: 'transparent'
                  }}
                >
                  <div style={{ marginBottom: '12px' }}>
                    {stat.icon}
                  </div>
                  <Statistic
                    value={stat.value}
                    valueStyle={{ 
                      fontSize: '32px',
                      fontWeight: '600',
                      color: '#1a1a1a',
                      lineHeight: '1.2'
                    }}
                  />
                  <Text 
                    style={{ 
                      fontSize: '16px',
                      color: '#666',
                      display: 'block',
                      marginTop: '6px',
                      lineHeight: '1.4'
                    }}
                  >
                    {stat.label}
                  </Text>
                </Card>
              ))}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default SocialProof; 